import { Base, createApp } from '@studiometa/js-toolkit';
import { isDev } from './config';

import CareersSlider from './components/CareersSlider';
import Header from './components/Header';
import Team from './components/Team';
import Testimonials from './components/Testimonials';
import Tabs from './components/Tabs';
import Form from './components/Form';
import ScrollTo from './components/ScrollTo';
import Loader from './components/Loader';
import FrontPageVideo from './components/FrontPageVideo';

/**
 * Main App class.
 */
class App extends Base {
  /**
   * App config.
   * @return {Object}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      CareersSlider,
      Header,
      Team,
      Testimonials,
      Tabs,
      Form,
      ScrollTo,
      Loader,
      FrontPageVideo,
    },
  };

  /**
   * Log a nice message when app is ready.
   *
   * @return {void}
   */
  mounted() {
    this.$log('mounted 🎉');

    if (window.location.hash === '#epione-video-3d') {
      document.getElementById('epione-video-3d').scrollIntoView({ block: 'center' });
    }
  }
}

export default createApp(App, document.body);
